import React, { useContext } from 'react';
import { AuthContext } from '../../../../shared/context/auth-context';
import Card from '../../../../shared/components/UIElements/Card';
import MendItem from './mendItem';

import './mendList.css';
import { Link } from 'react-router-dom/cjs/react-router-dom';


const MendList = (mends) => {

  const auth = useContext(AuthContext)
    if(mends.mends.length === 0) {
        return (
            <div>
              <Card>
                <h2>Мэдээ байхгүй</h2>
              </Card>
            </div>
            
        )
    };

    return (
        <div className='mend-list-container'>

          {/* Add new button only Visible for Admin */}
          {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && ( 
            <Link to='/add-mend' style={{textDecoration: 'none'}}>
              <div className='add-mend'>+ Add New</div>
              <hr className='hr-style'/>
            </Link>
          )}

          {mends.mends.map((mend, index) => (
            <div key={index}>     
              <MendItem          
                id={mend.id}
                name={mend.name}
                title={mend.title}
                article={mend.article}
                image={mend.image}
              /> 
            </div>  
          ))}        
        </div> 
    )
}
export default MendList;